import type { ILoanTransaction } from "@/modules/loan/common/types";
import { CURRENCY } from "@/shared/common/constants";
import { formatDate } from "@/shared/helpers";
import type { ICellProps } from "@ab.uitools/ui-library/components/AdvancedTable/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  t: (s: string) => string;
}

export const getColumns = ({ t }: Props) => ([
  {
    id: "creationDate",
    header: t("loans.historyTable.date"),
    accessorKey: "creationDate",
    enableHiding: false,
    cell: ({ row }: ICellProps<ILoanTransaction>) => {
      const date = formatDate(row.original?.creationDate);
      return (
        <Text>{date}</Text>
      );
    }
  },
  {
    id: "description",
    header: t("loans.historyTable.description"),
    accessorKey: "description",
    enableHiding: false,
  },
  {
    id: "amount",
    header: t("loans.historyTable.amount"),
    accessorKey: "amount",
    enableHiding: false,
    cell: ({ row }: ICellProps<ILoanTransaction>) => {
      const amount = row.original?.amount;
      const currency = row.original?.currency;
      return (
        <Text>{`${amount} ${CURRENCY[currency]?.symbol}`}</Text>
      );
    },
  },
]);
